'use client';
import Link from 'next/link';
import { capturePlanBrowseStarted } from 'lib/analytics';
import { ReactElement } from 'react';

interface MenuButtonProps {
  label: string;
  slug: string;
  toggleMenu: () => void;
  dataTestId?: string;
  isCurrentPage?: boolean;
}

export default function MenuButton({
  dataTestId,
  label,
  slug,
  toggleMenu,
  isCurrentPage = false,
}: MenuButtonProps): ReactElement {
  return (
    <Link
      href={slug}
      onClick={() => {
        if (slug === '/browse/plans') {
          capturePlanBrowseStarted('nav');
        }
        toggleMenu();
      }}
      className="menu-button"
      aria-current={isCurrentPage ? 'page' : undefined}
    >
      <span data-testid={dataTestId}>{label}</span>
    </Link>
  );
}
